import { useState, useEffect } from "react";
import { Button, Col, Form, Input, Modal, Radio, Row, Table, Tag } from "antd";
import { KeyOutlined, CloseOutlined } from "@ant-design/icons";
import GrupoFrasesRequest from "../../Paginas/CadastroGrupoFrases/GrupoFrasesRequest";
import { colors } from "../../Utils/temas";

function SelGrupoFrase({ onSelecionado, visible, onCancel }) {
  const [GrupoFrase, setGrupoFrase] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);
  const [linhaSelecionada, setLinhaSelecionada] = useState(null);
  const [form_pesquisa] = Form.useForm();
  const [filtros, setFiltros] = useState([]);

  function handleOk() {
    onSelecionado(linhaSelecionada);
  }

  const columns = [
    {
      title: "Descrição",
      dataIndex: "descricao",
    },
    {
      title: "Dia inicio",
      dataIndex: "dia_inicio",
    },
    {
      title: "Dia fim",
      dataIndex: "dia_fim",
    },
    {
      title: "Mês",
      dataIndex: "mes",
    },
    {
      title: "Situação",
      dataIndex: "situacao",
      key: "situacao",
      render: (situacao) => {
        let situacao_descricao = "";
        let color = "";

        if (situacao === "A") {
          situacao_descricao = "Ativo";
          color = "green";
        } else {
          situacao_descricao = "Inativo";
          color = "red";
        }
        return <Tag color={color}> {situacao_descricao} </Tag>;
      },
    },
  ];

  async function FetchRecords(page, pageSize, params) {
    setLoading(true);
    const response = await GrupoFrasesRequest.getListaGrupoFrases(
      page,
      pageSize,
      params
    );
    if (response.status === 200) {
      setGrupoFrase(response.data.results);
      setTotalRecords(response.data.count);
      setLoading(false);
    }
  }

  function SelecionarLinha(selectedRowKeys, selectedRows) {
    setLinhaSelecionada(selectedRows[0]);
  }

  async function onPesquisarClick(value) {
    setFiltros(value);
    FetchRecords(1, 10, value);
  }

  const Limpar = () => {
    setFiltros([]);
    form_pesquisa.resetFields();
    FetchRecords(1, 10, {});
  };

  useEffect(() => {
    FetchRecords(1, 10, {});
  }, []);

  return (
    <Modal
      width={800}
      title="Selecionar Grupo"
      visible={visible}
      onOk={() => handleOk()}
      onCancel={onCancel}
      destroyOnClose={true}
      centered
      bodyStyle={{ height: "80vh", overflowX: "scroll" }}
    >
      <>
        <Form
          form={form_pesquisa}
          layout="vertical"
          onFinish={onPesquisarClick}
          preserve={true}
        >
          <Row gutter={10}>
            <Col span={12}>
              <Form.Item name="descricao" label="Descrição">
                <Input />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item name="situacao" label="Situação">
                <Radio.Group>
                  <Radio value={"A"}>Ativo</Radio>
                  <Radio value={"I"}>Inativo</Radio>
                </Radio.Group>
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={10}>
            <Col span={12}>
              <Button
                htmlType="submit"
                style={{
                  background: colors.secondary,
                  color: "white",
                  fontWeight: "500",
                }}
                className="botao"
              >
                <KeyOutlined />
                Pesquisar
              </Button>
            </Col>

            <Col span={3} push={9}>
              <Button onClick={Limpar}>
                <CloseOutlined />
                Limpar
              </Button>
            </Col>
          </Row>
        </Form>
      </>
      <Table
        loading={loading}
        columns={columns}
        size="small"
        rowKey={"id"}
        rowSelection={{
          type: "radio",
          onChange: SelecionarLinha,
        }}
        dataSource={GrupoFrase}
        pagination={{
          total: totalRecords,
          showTotal: (total) => (
            <span
              style={{ fontWeight: "500", position: "absolute", left: "4%" }}
            >
              Quantidade: {total}
            </span>
          ),
          onChange: (page, pagaSize) => {
            FetchRecords(page, pagaSize, filtros);
          },
        }}
      />
    </Modal>
  );
}
export default SelGrupoFrase;
